import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

export const updateAssetId = async (payload: any) => {
  try {
    const awsTokens = await fetchAuthSession();
    const authHeader = 'bwdevenv';
    
    if (!authHeader) {
      throw new Error("Authentication token not found.");
    }

    const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/asset/rename`;
    const headers = {
      Authorization: authHeader,
    };

    // Make the POST request using axios
    const response = await axios.post(url, payload, { headers });

    return response.data;
  } catch (error) {
    console.error('Error updating asset ID:', error);
    // Re-throw the error so the component can handle it
    throw error;
  }
};